import React, { useEffect, useState } from "react";
import { Navbar } from "../Common/Navbar/Navbar";
import { Footer } from "../Common/Footer/Footer";
import axios from "axios";
import { base_url } from "../../Components/Auth/BackendAPIUrl";
import { Helmet } from "react-helmet-async";
import { Bgloader } from "../Common/Background/Bgloader";

const PrivacyPolicy = ({ lang, setLang }) => {
  const [privacyData, setPrivacyData] = useState(null);
  const [loading, setLoading] = useState(true);

  const getPrivacyContent = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${base_url}/cms/privacy-policy/`);
      if (response.data && response.data.length > 0) {
        setPrivacyData(response.data[0]);
      }
    } catch (error) {
      console.error("Error fetching Privacy Policy:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPrivacyContent();
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy | Bundl Designs</title>
        <meta
          name="description"
          content="Our commitment to your privacy. This policy outlines how Bundl Designs collects, uses, and protects your personal information."
        />
        <meta
          name="keywords"
          content="privacy policy, data protection, user privacy"
        />

        <meta property="og:title" content="Privacy Policy | Bundl Designs" />
        <meta
          property="og:description"
          content="Our commitment to your privacy. This policy outlines how Bundl Designs collects, uses, and protects your personal information."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://bundldesigns.com/privacy-policy"
        />

        <meta name="twitter:title" content="Privacy Policy | Bundl Designs" />
        <meta
          name="twitter:description"
          content="Our commitment to your privacy. This policy outlines how Bundl Designs collects, uses, and protects your personal information."
        />
      </Helmet>
      {loading ? (
        <Bgloader />
      ) : (
        <div>
          <Navbar isLang={lang} setIsLang={setLang} />
          <div className="font-Helvetica">
            <div className="text-center py-2 border-b border-black">
              <h1 className="lg:text-[40px] md:text-[40px] xs:text-[30px] lg:mt-[2%] md:mt-[2%] xs:mt-[5%] uppercase">
                {lang === "ar" ? "سياسة الخصوصية" : " Privacy Policy"}{" "}
              </h1>
            </div>
            <div className="lg:my-[3%] md:my-[5%] xs:my-[5%] lg:p-0 md:p-0 xs:p-[1%_5%]">
              <div
                className={`flex flex-col items-center justify-center mx-auto w-full ${
                  lang === "ar" ? "text-right" : "text-left"
                }`}
              >
                <div
                  className="w-full lg:max-w-[85%] md:max-w-[90%] xs:max-w-[100%] mt-2"
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "ar"
                        ? privacyData?.detail_arabic
                        : privacyData?.detail_english,
                  }}
                />
              </div>
            </div>
          </div>
          <Footer isLang={lang} />
        </div>
      )}
    </>
  );
};

export default PrivacyPolicy;
